import Button from 'components/button'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'

import { H1Congrats, PCongrats } from '../../../../theme/trivias'

const Congrats = ({ item }: any) => {

  const [{ user }] = useSession()
  const { history } = useRouter()

  return (
    <div className="flex justify-center items-center gap-4 flex-col p-7">
      <div className='flex-1 w-full flex justify-center items-center gap-4 flex-col'>
        <H1Congrats className="text-center text-5xl uppercase font-bold">¡Veeeeeeenga {user?.firstName}!</H1Congrats>
        <PCongrats className="text-center din uppercase">GANASTE <b>{item}</b></PCongrats>
      </div>
      <Button onClick={() => history.goBack()}>SEGUIR GANANDO CON TRIVIAS</Button>
    </div>
  )
}

export default Congrats
